module.exports = {
      id: "eagle_plan_bg-usage",
      viewBox: "0 0 44.096 49.152",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#eagle_plan_bg-usage",
      toString: function () {
        return this.url;
      }
    }